import { proxyCustomElement, HTMLElement, createEvent, h, Fragment } from '@stencil/core/internal/client';
import { s as state } from './index3.js';
import { d as defineCustomElement$1 } from './button-base2.js';

import { baseCss } from './css.js';
const nlSigninCss = baseCss;

const NlSigninStyle0 = nlSigninCss;

const NlSignin = /*@__PURE__*/ proxyCustomElement(class NlSignin extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.nlLogin = createEvent(this, "nlLogin", 7);
        this.nlCheckLogin = createEvent(this, "nlCheckLogin", 7);
        this.titleLogin = 'Connect to key store';
        this.description = 'Please enter your user name.';
        this.isGood = false;
    }
    handleInputChange(event) {
        state.nlSignin.loginName = event.target.value;
        this.nlCheckLogin.emit(event.target.value);
    }
    handleLogin(e) {
        e.preventDefault();
        this.nlLogin.emit(state.nlSignin.loginName);
    }
    render() {
        return (h(Fragment, { key: '9375186e2638a4ec14c0fd6bd4954c68a6695d0a' }, h("div", { key: '915342c0300b6ac7f6c5c84060117cf4b54c1bb2', class: "p-4 overflow-y-auto" }, h("h1", { key: 'c43f028b47c5ac566afda65cca1728fdade271a8', class: "nl-title font-bold text-center text-2xl" }, this.titleLogin), h("p", { key: 'd55111de6c8da0e06b957eb97fc66c3f25dd19a0', class: "nl-description font-light text-center text-sm pt-2 max-w-96 mx-auto" }, this.description)), h("div", { key: '4105fbbe19bf83b1eb23d2b75bf936abc121db52', class: "max-w-72 mx-auto" }, h("div", { key: '319964a6a9cdce3e2857a3722212f9f2c14a9657', class: "relative mb-2" }, h("input", { key: '5016006907ecde3717f9ef32a04a5a93e5e8dd1c', onInput: e => this.handleInputChange(e), type: "text", class: "nl-input peer py-3 px-4 ps-11 block w-full border-transparent rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none dark:border-transparent", placeholder: "name@domain.com", value: state.nlSignin.loginName }), h("div", { key: '1a02c7e5b6ece79557e05c67f10fae224b3eab13', class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4 peer-disabled:opacity-50 peer-disabled:pointer-events-none" }, h("svg", { key: '4ed7bc02af0383f5d378132df916a40eab90594d', xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "2", stroke: this.isGood ? '#00cc00' : 'currentColor', class: "flex-shrink-0 w-4 h-4 text-gray-500" }, h("path", { key: 'f6d18366b44aaa84f72a7f4c8c6bc4de9d914254', "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" })))), h("div", { key: '9325a0734cee2e749f8d0bd24177f0ae98031769', class: "ps-4 pe-4 overflow-y-auto" }, h("p", { key: '692b415ff9e06d6c79cd893bb01eadb6cc0dcaf6', class: "nl-error font-light text-center text-sm max-w-96 mx-auto" }, state.error)), h("button-base", { key: 'b53079a6c2d6551ab18f9abe46d28bcfa3ee1e63', titleBtn: "Connect", disabled: state.isLoading, onClick: e => this.handleLogin(e) }, state.isLoading ? (h("span", { slot: "icon-start", class: "animate-spin-loading inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-slate-900 dark:text-gray-300 rounded-full", role: "status", "aria-label": "loading" })) : (h("svg", { style: { display: 'none' }, slot: "icon-start", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor" }, h("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" })))))));
    }
    static get style() { return NlSigninStyle0; }
}, [0, "nl-signin", {
        "titleLogin": [1, "title-login"],
        "description": [1],
        "isGood": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-signin", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-signin":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlSignin);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlSignin as N, defineCustomElement as d };

//# sourceMappingURL=nl-signin2.js.map